import * as routes from "../constants/routes";

const routeItems = [
  {
    path: routes.DASHBOARD,
    component: 'Dashboard',
    policy: 'dashboard.index',
  },
  {
    policy: 'customers.index',
    path: routes.CUSTOMERS,
    component: 'Customers',
  },

  {
    policy: 'customers.index',
    path: routes.CUSTOMER_DASHBOARD,
    component: 'Customer/Details',
  },

  {
    policy: 'masterdata.index',
    path: routes.PAPERS,
    component: 'Papers',
  },

  {
    policy: 'masterdata.index',
    path: routes.ROUNDS,
    component: 'Round',
  },
  {
    policy: 'masterdata.index',
    path: routes.BRANCHES,
    component: 'Branches',
  },
  {
    policy: 'masterdata.index',
    path: routes.BRANCHVIEW,
    component: 'Branches/View',
  },
  {
    policy: 'masterdata.index',
    path: routes.CUSTOMER_PAPERS,
    component: 'Customer/Papers',
  },

  {
    policy: 'masterdata.index',
    path: routes.CUSTOMER_HOLIDAYS,
    component: 'Customer/Holidays',
  },

  {
    policy: 'masterdata.index',
    path: routes.CUSTOMER_VOUCHERS,
    component: 'Customer/Vouchers',
  },

  {
    policy: 'masterdata.index',
    path: routes.CUSTOMER_ADDITIONAL_PAPERS,
    component: 'Customer/Additional-Paper',
  },

  {
    policy: 'masterdata.index',
    path: routes.CUSTOMER_TRANSACTION,
    component: 'Customer/Payments',
  },
  {
    policy: 'management.index',
    path: routes.VOUCHERS,
    component: 'Vouchers',
  },
  {
    policy: 'management.index',
    path: routes.PAYMENTS,
    component: 'Payments',
  },
  {
    policy: 'management.index',
    path: routes.ASSIGNED_PAPERS,
    component: 'Assigned-Papers',
  },
  {
    policy: 'access.index',
    path: routes.ROLES,
    component: 'Access/Roles',
  },
  {
    policy: 'access.index',
    path: routes.USERS,
    component: 'Access/Users',
  },
  {
    policy: 'reports.index',
    path: routes.CUSTOMERS_QUERY,
    component: 'Customer-Query',
  },
  {
    policy: 'reports.index',
    path: routes.PAPER_QUERY,
    component: 'Paper-Query',
  },
  {
    policy: 'masterdata.index',
    path: routes.DELIVERY_FEE,
    component: 'Delivery-Fees',
  },
];

export default routeItems;
